import { render, staticRenderFns } from "./UserRoleAccess.vue?vue&type=template&id=16e2efe1&scoped=true&"
import script from "./UserRoleAccess.vue?vue&type=script&lang=ts&"
export * from "./UserRoleAccess.vue?vue&type=script&lang=ts&"
import style0 from "./UserRoleAccess.vue?vue&type=style&index=0&id=16e2efe1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e2efe1",
  null
  
)

export default component.exports